import React from 'react';
type ArchLinesProps = {
  className?: string;
};

/**
 * Ventana en arco del estudio (motivo del mockup DPS47). Hereda el color
 * via `currentColor`.
 */
export function ArchLines({
  className
}: ArchLinesProps) {
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true" className={className} data-id="element-22" data-mp="ox62h8ypgmhh">
      <path d="M40 236V110a80 80 0 0 1 160 0v126" data-id="element-23" data-mp="f737j380wygi" />
      <path d="M60 236V112a60 60 0 0 1 120 0v124" data-id="element-24" data-mp="jyuqosouo1wm" />
      <path d="M120 52v184" data-id="element-25" data-mp="jzo061f715ig" />
      <path d="M60 140h120" data-id="element-26" data-mp="k0z6a7w42pcq" />
      <path d="M60 188h120" data-id="element-27" data-mp="67q00g3gmjyf" />
    </svg>;
}